export default "__VITE_ASSET__3a07fbd3__"